class CartDrawer extends HTMLElement {
  connectedCallback() {
    if(this.bound)return;this.bound=true;
    this.addEventListener('click',e=>{if(e.target.closest('[data-bc-close]')||!e.target.closest('.bc-drawer-panel'))this.close();});
    this.addEventListener('keydown',e=>{
      if(e.key==='Escape'){e.preventDefault();this.close();}
      if(e.key==='Tab'){
        const nodes=[...this.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),textarea,[tabindex="0"]')].filter(n=>n.getClientRects().length);
        const first=nodes[0],last=nodes[nodes.length-1];
        if(e.shiftKey&&(document.activeElement===first||document.activeElement===this.querySelector('.bc-drawer-panel'))){e.preventDefault();last?.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
      }
    });
    document.addEventListener('click',e=>{
      const link=e.target.closest('#cart-icon-bubble,[data-bc-open-cart]');
      if(!link||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0)return;
      e.preventDefault();this.open(link);
    });
    const bind=()=>{if(window.BuddyCart&&!this.cartBound){window.BuddyCart.bind(this);this.cartBound=true;}};
    bind();if(!this.cartBound)document.addEventListener('DOMContentLoaded',bind,{once:true});
  }
  setActiveElement(element){this.activeElement=element;}
  getSectionsToRender(){return (window.BuddyCart?.sections()||['cart-drawer','cart-icon-bubble']).map(id=>({id}));}
  async renderContents(result){
    try{window.BuddyCart.render(result.sections);this.open(undefined,true);}
    catch{try{await window.BuddyCart.refresh();this.open(undefined,true);}catch{location.assign(window.routes.cart_url);}}
  }
  open(trigger,added=false){
    if(trigger)this.activeElement=trigger;
    if(!this.activeElement)this.activeElement=document.activeElement;
    document.querySelector('buddy-navigation')?.closeAll();
    this.hidden=false;this.classList.add('active');
    this.querySelector('[data-bc-added]').hidden=!added;
    document.body.classList.add('overflow-hidden');
    this.background=[...document.body.children].filter(n=>n!==this&&!['SCRIPT','STYLE','LINK'].includes(n.tagName)&&!n.inert);
    this.background.forEach(n=>n.inert=true);
    this.querySelector('.bc-drawer-panel').focus({preventScroll:true});
  }
  close(){
    this.hidden=true;this.classList.remove('active');this.background?.forEach(n=>n.inert=false);this.background=[];
    document.body.classList.remove('overflow-hidden');
    if(this.activeElement?.isConnected)this.activeElement.focus({preventScroll:true});
  }
}
customElements.define('cart-drawer',CartDrawer);

